import React from 'react';
import { Authentic } from './InnerContent/Authentic';
import { Shipping } from './InnerContent/Shipping';
import { SecureShopping } from './InnerContent/SecureShopping';
import { CustomerSupport } from './InnerContent/CustomerSupport';
import { AuthenticTitle, CustomerSupportTitle, SecureShoppingTitle, ShippingTitle } from './titles';

export const boxContent = [
  {
    innerComponent: () => <Authentic />,
    title: AuthenticTitle,
  },
  {
    innerComponent: () => <Shipping />,
    title: ShippingTitle,
  },
  {
    innerComponent: () => <SecureShopping />,
    title: SecureShoppingTitle,
  },
  {
    innerComponent: () => <CustomerSupport />,
    title: CustomerSupportTitle,
  },
];
